export const name = 'Server';
import { useMainStore } from '@/stores/main'
import * as Language from '@/services/Language'
import axios from 'axios'
import * as Alerts from '@/services/Alerts'
import * as Auth from '@/services/Auth'

export async function call(method, page, data, addOptions) {
  const store = useMainStore()
  store.startLoading(page);

  return axios({
    method: method,
    url: store.env('SERVER_URL') + 'api/' + page,
    ...(data ? { data: data } : null),
    ...getRequestOptions(addOptions)
  })
  .catch(error => {
    //console.log('SERVER error', error)
    if (error.response){
      // Session expired: revoke token and (@todo refresh page to redirect to login).
      // Skip this for login calls, where 401 means invalid credentials.
      if (error.response.status == 401 && !page.includes('login')){
        Auth.revokeToken()
        Alerts.warning('Session expired')
      }
      // if (error.response.data && error.response.data.message){
      //   Alerts.error(error.response.data.message)
      // }
    }

    throw error;
  })
  .finally(() => {
    store.finishedLoading(page)
  })
}


export async function get(page, addOptions)
{ 
  return call('get', page, null, addOptions);
}

export async function post(page, data, addOptions)
{
  return call('post', page, data, addOptions);
}

export async function put(page, data, addOptions)
{
  return call('put', page, data, addOptions);
}

export async function del(page, data, addOptions)
{
  return call('delete', page, data, addOptions);
}

export async function destroy(page)
{
  return call('delete', page);
}

export async function download(path, fileName)
{
  try {
    const response = await get(path, {
      responseType: 'blob',
    });

    // Crea un URL temporaneo per il blob e avvia il download.
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    // Pulizia.
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download error", error);
    throw error;
  }
}

export function getRequestOptions(addOptions)
{
  const options = {
    headers: {
      // The server writes its own messages (validation above all) in the language the user is
      // browsing with: see the SetLocale middleware, which reads this header.
      'Accept-Language': Language.current(),
    },
  };

  if (Auth.getToken()){
    options.headers['Authorization'] = `Bearer ${Auth.getToken()}`
  }
  // Add headers.
  if (addOptions){
    if (addOptions.headers){
      for (let h in addOptions.headers){
        options.headers[h] = addOptions.headers[h]
      }
    }
    if (addOptions.responseType){
      options.responseType = addOptions.responseType
    }
  }
  return options
}
